import React,{Component} from 'react'
import ActiveWrapper from "../components/common/ActiveWrapper";
import oneImg from  '../images/office_img/img-1.jpg'
import twoImg from '../images/office_img/img-2.jpg'
import newImg from '../images/office_img/img-4.jpg'
import threeImg from '../images/office_img/img-5.jpg'
import fourImg from '../images/office_img/img-12.jpg'
import fiveImg from '../images/office_img/img-6.jpg'
import sevenImg from '../images/office_img/img-13.jpg'
import eightImg from '../images/office_img/img-7.jpg'
import {Link} from 'react-router-dom'
import OpenPosition from '../components/OpenPosition'
import JobDescription from '../components/JobDescription'

class MixGrid extends Component{
    render(){
        return <div className={'mix-grid'}>
            <div className={'column'}>
                <div className={'first-layout layout'}>
                    <div className={'sub-layout'}>
                        <div className={'col details'}>
                            <div className={'head'}>Our Team</div>
                            <p>Hubler has a highly motivated and immensely skilled group of people who bring diversity, passion and fun to the work floor. An informal yet well catered work environment provides enough vent to their interests.</p>
                        </div>
                        <div className={'col img'} style={{backgroundImage:`url(${oneImg})`}}></div>
                    </div>
                    <div className={'sub-layout'}>
                        <div className={'col'} style={{height:'50%',backgroundImage:`url(${twoImg})`}}></div>
                        <div className={'col'} style={{height:'50%',backgroundImage:`url(${threeImg})`}}></div>
                    </div>
                </div>
                <div className={'secand-layout layout'}>
                    <div className={'sub-cls'}>
                        <div className={'col'} style={{height:'100%',backgroundImage:`url(${sevenImg})`}}></div>
                        <div className={'col'} style={{height:'100%',backgroundImage:`url(${eightImg})`}}></div>
                        <div className={'col'} style={{height:'100%',backgroundImage:`url(${newImg})`}}></div>
                    </div>
                    <div className={'sub-cls-2'}>
                        <div className={'col'} style={{height:'100%',backgroundImage:`url(${fourImg})`}}></div>
                        <div className={'col'} style={{height:'100%',backgroundImage:`url(${fiveImg})`}}></div>
                    </div>
                </div>
            </div>
        </div>
    }
}


export default class Career extends Component{
    state = {
        view:'',
        id:''
    }
    urlToState(location){
        const {search = ''} = location;
        const hashParam = search.substr(1);
        return hashParam.split('&').reduce(function (result, item) {
            const parts = item.split('=');
            result[parts[0]] = parts[1];
            return result;
            }, {})
    }
    render(){
        const urlData = this.urlToState(this.props.location) || {view:'', id:''};
        return <div className={'career-main-container'}>
            <ActiveWrapper active={urlData.view !== 'openPositions' && urlData.view !== 'job_description'}>
            <div>
            <div className={'heading'}>
                <div className={'details-head'}>
                    <div className={'head'}>Careers at Hubler</div>
                    <p>Hubler is an exciting SaaS startup that is revolutionising the way enterprises manage their business processes. We need a great team to achieve that. Join us and help bring business process automation to the fore.</p>
                </div>
            </div>
            <div className={'grid-list-view'}>
                <MixGrid/>
            </div>
            <div className={'company-details'}>
                <div className={'header-details'}>
                    <div className={'head'}>What you are signing up for</div>
                    <p>If workflow automation, bots & working on
                        some of the cutting-edge technological requirements excite you, then we welcome
                        you with open arms as you get to be a part of the first chapter & make an impact as the fun unfolds.
                    </p>
                </div>
                <div className={'secation-details'}>
                    <div className={'section-cls'}>
                        <div className={'head'}>No Hierarchy</div>
                        <p>A comfortable working atmosphere that follows a flat and open culture along with a great office space to ensure work gets done in peace.</p>
                    </div>
                    <div className={'section-cls'}>
                        <div className={'head'}>Mentorship</div>
                        <p>Work with industry leaders who love to mentor, give honest feedback, and help you grow in all directions, both professionally and personally.</p>
                    </div>
                    <div className={'section-cls'}>
                        <div className={'head'}>Flexible Working Hours</div>
                        <p>We love work and we think you will too. Break the mold, as you strive to bring the best in you, in your way! Put long hours or quality 9 hours, up to you.</p>
                    </div>
                    <div className={'section-cls'}>
                        <div className={'head'}>A Healthy Environment</div>
                        <p>Quality food that will warm your heart. Our culinary team serves delightful and nutritious
                            meals each day because hey! Good food equals good mood.</p>
                    </div>
                    <div className={'section-cls'}>
                        <div className={'head'}>Transparency and Autonomy</div>
                        <p>@Hubler everyone is empowered to make decisions, communication is transparent, and we are challenged to choose our own productivity.</p>
                    </div>
                    <div className={'section-cls'}>
                        <div className={'head'}>Exceptional Benefits</div>
                        <p>The peace at home is what matters! We got you covered from Insurance coverage to generous parental leave, we bring the best to the table.</p>
                    </div>

                </div>
            </div>
            <div className={'join-our-team-footer'}>
                <div className={'head'}>Join our team</div>
                <p>Interested in working together? We are too!</p>
                <Link to={{ pathname: `/career/`, search: `view=openPositions`}}>See Open Positions</Link>
            </div>
            </div>
            </ActiveWrapper>
            <ActiveWrapper active={urlData.view === 'openPositions'}>
                <OpenPosition/>
            </ActiveWrapper>
            <ActiveWrapper active={urlData.view === 'job_description'}>
                <JobDescription urlData={urlData} {...this.props}/>
            </ActiveWrapper>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/career.js